import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCmsAccordionWidgetContainer, LazyCmsAssetWidget, LazyCmsAwardsWidget, LazyCmsBackgroundHeader, LazyCmsBikeCarousel, LazyCmsBikefinderWidget, LazyCmsBlogHeader, LazyCmsCarouselCard, LazyCmsContentCarousel, LazyCmsContentController, LazyCmsContentHeader, LazyCmsContentSlider, LazyCmsFeatureSlider, LazyCmsFeatureVideoWidget, LazyCmsFriendbuyWidget, LazyCmsGeometryWidget, LazyCmsGleamWidget, LazyCmsGoogleFormWidgetContainer, LazyCmsHeroBanner, LazyCmsHeroSlider, LazyCmsHighlightsWidgetContainer, LazyCmsInfoBlockWidget, LazyCmsInlineNavWidgetContainer, LazyCmsIntroWidget, LazyCmsLinkWidget, LazyCmsLookbookCollageWidget, LazyCmsLookbookFooterWidget, LazyCmsLookbookHighlightWidget, LazyCmsLookbookSlideInWidget, LazyCmsLookbookWidgetContainer, LazyCmsLottieAnimationWidget, LazyCmsNewsletterWidget, LazyCmsProductAsset, LazyCmsProductCompareWidget, LazyCmsProductHighlightsContainer, LazyCmsProductIntro, LazyCmsProductList, LazyCmsProductSummaryWidget, LazyCmsProductsWidgetContainer, LazyCmsQuoteWidget, LazyCmsReviewsSliderWidget, LazyCmsReviewsUGCWidget, LazyCmsShopInfoPlacement, LazyCmsSpecificationWidget, LazyCmsTeaserWidgetContainer, LazyCmsTextBlock, LazyCmsTextSliderWidgetContainer, LazyCmsTextWidget, LazyCmsTypeFormWidget, LazyCmsUspWidgetContainer, LazyCmsVideoWidgetContainer, LazyCmsWidgetContainer, LazyCmsWowPlaceholderOne, LazyCmsWowPlaceholderTwo, LazyBikeExplore, LazyBikeWoom1, LazyBikeWoom1Plus, LazyBikeWoom2, LazyBikeWoom3, LazyBikeWoom4, LazyBikeWoom5, LazyBikeWoom6, LazyBikeWoomNow, LazyBikeWoomOff, LazyBikeWoomOffAir, LazyBikeWoomUp, LazyBikeWoomWow, LazyWoomIconAccessories, LazyWoomIconAddToCart, LazyWoomIconAlert, LazyWoomIconAlertCircle, LazyWoomIconAllTopics, LazyWoomIconAmex, LazyWoomIconApplePay, LazyWoomIconArrowDown, LazyWoomIconArrowDownCircle, LazyWoomIconArrowLeft, LazyWoomIconArrowRight, LazyWoomIconArrowUp, LazyWoomIconArrowUpCircle, LazyWoomIconAssembly, LazyWoomIconAward, LazyWoomIconBadgePinchFree, LazyWoomIconBadgePlus, LazyWoomIconBadgeProtect, LazyWoomIconBadgeSafe, LazyWoomIconBear, LazyWoomIconBell, LazyWoomIconBikeVerified, LazyWoomIconBiking, LazyWoomIconBikingLearner, LazyWoomIconBlik, LazyWoomIconBook, LazyWoomIconBox3D, LazyWoomIconBulb, LazyWoomIconCalendarAdd, LazyWoomIconCancellation, LazyWoomIconCap, LazyWoomIconCareer, LazyWoomIconCart, LazyWoomIconChallenges, LazyWoomIconCheck, LazyWoomIconChevronLeft, LazyWoomIconChevronRight, LazyWoomIconClose, LazyWoomIconCompany, LazyWoomIconDealer, LazyWoomIconDhl, LazyWoomIconDino, LazyWoomIconEdit, LazyWoomIconEps, LazyWoomIconErgonomic, LazyWoomIconExternalLinkCircle, LazyWoomIconFacebook, LazyWoomIconFaq, LazyWoomIconFedex, LazyWoomIconFilter, LazyWoomIconForProtection, LazyWoomIconForTheBike, LazyWoomIconForTheKid, LazyWoomIconForTheRide, LazyWoomIconFrame, LazyWoomIconFreeShipping, LazyWoomIconGift50, LazyWoomIconGift75, LazyWoomIconGloves, LazyWoomIconGls, LazyWoomIconGooglePay, LazyWoomIconHeadphones, LazyWoomIconHealth, LazyWoomIconHeart, LazyWoomIconHelpBubble, LazyWoomIconHighQuality, LazyWoomIconInformation, LazyWoomIconInformationCircle, LazyWoomIconInstagram, LazyWoomIconJackets, LazyWoomIconJournal, LazyWoomIconJourney, LazyWoomIconKlarna, LazyWoomIconKnowledge, LazyWoomIconLinkedin, LazyWoomIconLock, LazyWoomIconMaestro, LazyWoomIconMagicMoments, LazyWoomIconMastercard, LazyWoomIconMenu, LazyWoomIconMinus, LazyWoomIconMinusCircle, LazyWoomIconMoneyBack, LazyWoomIconMoneyBack60, LazyWoomIconMountainbike, LazyWoomIconNewsletter, LazyWoomIconOurStory, LazyWoomIconOutdoorRoad, LazyWoomIconPants, LazyWoomIconPaperPlane, LazyWoomIconParty, LazyWoomIconPaypal, LazyWoomIconPerfectGeometry, LazyWoomIconPinterest, LazyWoomIconPlay, LazyWoomIconPlayAndFun, LazyWoomIconPlus, LazyWoomIconPlusCircle, LazyWoomIconPress, LazyWoomIconProducts, LazyWoomIconProfile, LazyWoomIconPromoTag, LazyWoomIconProtectionShield, LazyWoomIconRedCharity, LazyWoomIconReturn, LazyWoomIconReturns, LazyWoomIconRocket, LazyWoomIconRoyalmail, LazyWoomIconRule, LazyWoomIconSearch, LazyWoomIconServiceGuy, LazyWoomIconShare, LazyWoomIconShipmentInprogress, LazyWoomIconShippingCost, LazyWoomIconShippingInfo, LazyWoomIconShopPay, LazyWoomIconSizeGuide, LazyWoomIconSlide, LazyWoomIconSocks, LazyWoomIconSoldout, LazyWoomIconSpareParts, LazyWoomIconSpareParts2, LazyWoomIconStarFull, LazyWoomIconStarHalf, LazyWoomIconStarOutline, LazyWoomIconStiftungWarentest, LazyWoomIconStopwatch, LazyWoomIconSustainability, LazyWoomIconSweater, LazyWoomIconTShirt, LazyWoomIconThumbsUp, LazyWoomIconTires, LazyWoomIconTracking, LazyWoomIconTrash, LazyWoomIconTrick, LazyWoomIconTripp, LazyWoomIconTruck, LazyWoomIconTwitter, LazyWoomIconUpTo10, LazyWoomIconUpTo15, LazyWoomIconUpTo20, LazyWoomIconUpTo40, LazyWoomIconUpcycling, LazyWoomIconUser, LazyWoomIconVerified, LazyWoomIconViewOff, LazyWoomIconViewOn, LazyWoomIconVisa, LazyWoomIconVisionAndValues, LazyWoomIconWallet, LazyWoomIconWarranty, LazyWoomIconWoom1, LazyWoomIconWoom3, LazyWoomIconWoom5, LazyWoomIconWoomLogo, LazyWoomIconWorld, LazyWoomIconYoutube, LazyPrimeToast } from '#components'
const lazyGlobalComponents = [
  ["CmsAccordionWidgetContainer", LazyCmsAccordionWidgetContainer],
["CmsAssetWidget", LazyCmsAssetWidget],
["CmsAwardsWidget", LazyCmsAwardsWidget],
["CmsBackgroundHeader", LazyCmsBackgroundHeader],
["CmsBikeCarousel", LazyCmsBikeCarousel],
["CmsBikefinderWidget", LazyCmsBikefinderWidget],
["CmsBlogHeader", LazyCmsBlogHeader],
["CmsCarouselCard", LazyCmsCarouselCard],
["CmsContentCarousel", LazyCmsContentCarousel],
["CmsContentController", LazyCmsContentController],
["CmsContentHeader", LazyCmsContentHeader],
["CmsContentSlider", LazyCmsContentSlider],
["CmsFeatureSlider", LazyCmsFeatureSlider],
["CmsFeatureVideoWidget", LazyCmsFeatureVideoWidget],
["CmsFriendbuyWidget", LazyCmsFriendbuyWidget],
["CmsGeometryWidget", LazyCmsGeometryWidget],
["CmsGleamWidget", LazyCmsGleamWidget],
["CmsGoogleFormWidgetContainer", LazyCmsGoogleFormWidgetContainer],
["CmsHeroBanner", LazyCmsHeroBanner],
["CmsHeroSlider", LazyCmsHeroSlider],
["CmsHighlightsWidgetContainer", LazyCmsHighlightsWidgetContainer],
["CmsInfoBlockWidget", LazyCmsInfoBlockWidget],
["CmsInlineNavWidgetContainer", LazyCmsInlineNavWidgetContainer],
["CmsIntroWidget", LazyCmsIntroWidget],
["CmsLinkWidget", LazyCmsLinkWidget],
["CmsLookbookCollageWidget", LazyCmsLookbookCollageWidget],
["CmsLookbookFooterWidget", LazyCmsLookbookFooterWidget],
["CmsLookbookHighlightWidget", LazyCmsLookbookHighlightWidget],
["CmsLookbookSlideInWidget", LazyCmsLookbookSlideInWidget],
["CmsLookbookWidgetContainer", LazyCmsLookbookWidgetContainer],
["CmsLottieAnimationWidget", LazyCmsLottieAnimationWidget],
["CmsNewsletterWidget", LazyCmsNewsletterWidget],
["CmsProductAsset", LazyCmsProductAsset],
["CmsProductCompareWidget", LazyCmsProductCompareWidget],
["CmsProductHighlightsContainer", LazyCmsProductHighlightsContainer],
["CmsProductIntro", LazyCmsProductIntro],
["CmsProductList", LazyCmsProductList],
["CmsProductSummaryWidget", LazyCmsProductSummaryWidget],
["CmsProductsWidgetContainer", LazyCmsProductsWidgetContainer],
["CmsQuoteWidget", LazyCmsQuoteWidget],
["CmsReviewsSliderWidget", LazyCmsReviewsSliderWidget],
["CmsReviewsUGCWidget", LazyCmsReviewsUGCWidget],
["CmsShopInfoPlacement", LazyCmsShopInfoPlacement],
["CmsSpecificationWidget", LazyCmsSpecificationWidget],
["CmsTeaserWidgetContainer", LazyCmsTeaserWidgetContainer],
["CmsTextBlock", LazyCmsTextBlock],
["CmsTextSliderWidgetContainer", LazyCmsTextSliderWidgetContainer],
["CmsTextWidget", LazyCmsTextWidget],
["CmsTypeFormWidget", LazyCmsTypeFormWidget],
["CmsUspWidgetContainer", LazyCmsUspWidgetContainer],
["CmsVideoWidgetContainer", LazyCmsVideoWidgetContainer],
["CmsWidgetContainer", LazyCmsWidgetContainer],
["CmsWowPlaceholderOne", LazyCmsWowPlaceholderOne],
["CmsWowPlaceholderTwo", LazyCmsWowPlaceholderTwo],
["BikeExplore", LazyBikeExplore],
["BikeWoom1", LazyBikeWoom1],
["BikeWoom1Plus", LazyBikeWoom1Plus],
["BikeWoom2", LazyBikeWoom2],
["BikeWoom3", LazyBikeWoom3],
["BikeWoom4", LazyBikeWoom4],
["BikeWoom5", LazyBikeWoom5],
["BikeWoom6", LazyBikeWoom6],
["BikeWoomNow", LazyBikeWoomNow],
["BikeWoomOff", LazyBikeWoomOff],
["BikeWoomOffAir", LazyBikeWoomOffAir],
["BikeWoomUp", LazyBikeWoomUp],
["BikeWoomWow", LazyBikeWoomWow],
["WoomIconAccessories", LazyWoomIconAccessories],
["WoomIconAddToCart", LazyWoomIconAddToCart],
["WoomIconAlert", LazyWoomIconAlert],
["WoomIconAlertCircle", LazyWoomIconAlertCircle],
["WoomIconAllTopics", LazyWoomIconAllTopics],
["WoomIconAmex", LazyWoomIconAmex],
["WoomIconApplePay", LazyWoomIconApplePay],
["WoomIconArrowDown", LazyWoomIconArrowDown],
["WoomIconArrowDownCircle", LazyWoomIconArrowDownCircle],
["WoomIconArrowLeft", LazyWoomIconArrowLeft],
["WoomIconArrowRight", LazyWoomIconArrowRight],
["WoomIconArrowUp", LazyWoomIconArrowUp],
["WoomIconArrowUpCircle", LazyWoomIconArrowUpCircle],
["WoomIconAssembly", LazyWoomIconAssembly],
["WoomIconAward", LazyWoomIconAward],
["WoomIconBadgePinchFree", LazyWoomIconBadgePinchFree],
["WoomIconBadgePlus", LazyWoomIconBadgePlus],
["WoomIconBadgeProtect", LazyWoomIconBadgeProtect],
["WoomIconBadgeSafe", LazyWoomIconBadgeSafe],
["WoomIconBear", LazyWoomIconBear],
["WoomIconBell", LazyWoomIconBell],
["WoomIconBikeVerified", LazyWoomIconBikeVerified],
["WoomIconBiking", LazyWoomIconBiking],
["WoomIconBikingLearner", LazyWoomIconBikingLearner],
["WoomIconBlik", LazyWoomIconBlik],
["WoomIconBook", LazyWoomIconBook],
["WoomIconBox3D", LazyWoomIconBox3D],
["WoomIconBulb", LazyWoomIconBulb],
["WoomIconCalendarAdd", LazyWoomIconCalendarAdd],
["WoomIconCancellation", LazyWoomIconCancellation],
["WoomIconCap", LazyWoomIconCap],
["WoomIconCareer", LazyWoomIconCareer],
["WoomIconCart", LazyWoomIconCart],
["WoomIconChallenges", LazyWoomIconChallenges],
["WoomIconCheck", LazyWoomIconCheck],
["WoomIconChevronLeft", LazyWoomIconChevronLeft],
["WoomIconChevronRight", LazyWoomIconChevronRight],
["WoomIconClose", LazyWoomIconClose],
["WoomIconCompany", LazyWoomIconCompany],
["WoomIconDealer", LazyWoomIconDealer],
["WoomIconDhl", LazyWoomIconDhl],
["WoomIconDino", LazyWoomIconDino],
["WoomIconEdit", LazyWoomIconEdit],
["WoomIconEps", LazyWoomIconEps],
["WoomIconErgonomic", LazyWoomIconErgonomic],
["WoomIconExternalLinkCircle", LazyWoomIconExternalLinkCircle],
["WoomIconFacebook", LazyWoomIconFacebook],
["WoomIconFaq", LazyWoomIconFaq],
["WoomIconFedex", LazyWoomIconFedex],
["WoomIconFilter", LazyWoomIconFilter],
["WoomIconForProtection", LazyWoomIconForProtection],
["WoomIconForTheBike", LazyWoomIconForTheBike],
["WoomIconForTheKid", LazyWoomIconForTheKid],
["WoomIconForTheRide", LazyWoomIconForTheRide],
["WoomIconFrame", LazyWoomIconFrame],
["WoomIconFreeShipping", LazyWoomIconFreeShipping],
["WoomIconGift50", LazyWoomIconGift50],
["WoomIconGift75", LazyWoomIconGift75],
["WoomIconGloves", LazyWoomIconGloves],
["WoomIconGls", LazyWoomIconGls],
["WoomIconGooglePay", LazyWoomIconGooglePay],
["WoomIconHeadphones", LazyWoomIconHeadphones],
["WoomIconHealth", LazyWoomIconHealth],
["WoomIconHeart", LazyWoomIconHeart],
["WoomIconHelpBubble", LazyWoomIconHelpBubble],
["WoomIconHighQuality", LazyWoomIconHighQuality],
["WoomIconInformation", LazyWoomIconInformation],
["WoomIconInformationCircle", LazyWoomIconInformationCircle],
["WoomIconInstagram", LazyWoomIconInstagram],
["WoomIconJackets", LazyWoomIconJackets],
["WoomIconJournal", LazyWoomIconJournal],
["WoomIconJourney", LazyWoomIconJourney],
["WoomIconKlarna", LazyWoomIconKlarna],
["WoomIconKnowledge", LazyWoomIconKnowledge],
["WoomIconLinkedin", LazyWoomIconLinkedin],
["WoomIconLock", LazyWoomIconLock],
["WoomIconMaestro", LazyWoomIconMaestro],
["WoomIconMagicMoments", LazyWoomIconMagicMoments],
["WoomIconMastercard", LazyWoomIconMastercard],
["WoomIconMenu", LazyWoomIconMenu],
["WoomIconMinus", LazyWoomIconMinus],
["WoomIconMinusCircle", LazyWoomIconMinusCircle],
["WoomIconMoneyBack", LazyWoomIconMoneyBack],
["WoomIconMoneyBack60", LazyWoomIconMoneyBack60],
["WoomIconMountainbike", LazyWoomIconMountainbike],
["WoomIconNewsletter", LazyWoomIconNewsletter],
["WoomIconOurStory", LazyWoomIconOurStory],
["WoomIconOutdoorRoad", LazyWoomIconOutdoorRoad],
["WoomIconPants", LazyWoomIconPants],
["WoomIconPaperPlane", LazyWoomIconPaperPlane],
["WoomIconParty", LazyWoomIconParty],
["WoomIconPaypal", LazyWoomIconPaypal],
["WoomIconPerfectGeometry", LazyWoomIconPerfectGeometry],
["WoomIconPinterest", LazyWoomIconPinterest],
["WoomIconPlay", LazyWoomIconPlay],
["WoomIconPlayAndFun", LazyWoomIconPlayAndFun],
["WoomIconPlus", LazyWoomIconPlus],
["WoomIconPlusCircle", LazyWoomIconPlusCircle],
["WoomIconPress", LazyWoomIconPress],
["WoomIconProducts", LazyWoomIconProducts],
["WoomIconProfile", LazyWoomIconProfile],
["WoomIconPromoTag", LazyWoomIconPromoTag],
["WoomIconProtectionShield", LazyWoomIconProtectionShield],
["WoomIconRedCharity", LazyWoomIconRedCharity],
["WoomIconReturn", LazyWoomIconReturn],
["WoomIconReturns", LazyWoomIconReturns],
["WoomIconRocket", LazyWoomIconRocket],
["WoomIconRoyalmail", LazyWoomIconRoyalmail],
["WoomIconRule", LazyWoomIconRule],
["WoomIconSearch", LazyWoomIconSearch],
["WoomIconServiceGuy", LazyWoomIconServiceGuy],
["WoomIconShare", LazyWoomIconShare],
["WoomIconShipmentInprogress", LazyWoomIconShipmentInprogress],
["WoomIconShippingCost", LazyWoomIconShippingCost],
["WoomIconShippingInfo", LazyWoomIconShippingInfo],
["WoomIconShopPay", LazyWoomIconShopPay],
["WoomIconSizeGuide", LazyWoomIconSizeGuide],
["WoomIconSlide", LazyWoomIconSlide],
["WoomIconSocks", LazyWoomIconSocks],
["WoomIconSoldout", LazyWoomIconSoldout],
["WoomIconSpareParts", LazyWoomIconSpareParts],
["WoomIconSpareParts2", LazyWoomIconSpareParts2],
["WoomIconStarFull", LazyWoomIconStarFull],
["WoomIconStarHalf", LazyWoomIconStarHalf],
["WoomIconStarOutline", LazyWoomIconStarOutline],
["WoomIconStiftungWarentest", LazyWoomIconStiftungWarentest],
["WoomIconStopwatch", LazyWoomIconStopwatch],
["WoomIconSustainability", LazyWoomIconSustainability],
["WoomIconSweater", LazyWoomIconSweater],
["WoomIconTShirt", LazyWoomIconTShirt],
["WoomIconThumbsUp", LazyWoomIconThumbsUp],
["WoomIconTires", LazyWoomIconTires],
["WoomIconTracking", LazyWoomIconTracking],
["WoomIconTrash", LazyWoomIconTrash],
["WoomIconTrick", LazyWoomIconTrick],
["WoomIconTripp", LazyWoomIconTripp],
["WoomIconTruck", LazyWoomIconTruck],
["WoomIconTwitter", LazyWoomIconTwitter],
["WoomIconUpTo10", LazyWoomIconUpTo10],
["WoomIconUpTo15", LazyWoomIconUpTo15],
["WoomIconUpTo20", LazyWoomIconUpTo20],
["WoomIconUpTo40", LazyWoomIconUpTo40],
["WoomIconUpcycling", LazyWoomIconUpcycling],
["WoomIconUser", LazyWoomIconUser],
["WoomIconVerified", LazyWoomIconVerified],
["WoomIconViewOff", LazyWoomIconViewOff],
["WoomIconViewOn", LazyWoomIconViewOn],
["WoomIconVisa", LazyWoomIconVisa],
["WoomIconVisionAndValues", LazyWoomIconVisionAndValues],
["WoomIconWallet", LazyWoomIconWallet],
["WoomIconWarranty", LazyWoomIconWarranty],
["WoomIconWoom1", LazyWoomIconWoom1],
["WoomIconWoom3", LazyWoomIconWoom3],
["WoomIconWoom5", LazyWoomIconWoom5],
["WoomIconWoomLogo", LazyWoomIconWoomLogo],
["WoomIconWorld", LazyWoomIconWorld],
["WoomIconYoutube", LazyWoomIconYoutube],
["PrimeToast", LazyPrimeToast],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
